import { LeftSectionStatsTranslations } from "./types";

export const enTranslations: LeftSectionStatsTranslations = {
    patients: "Patients",
    students: "Students",
    sessions: "Sessions",
    averageScore: "Average Score"
};